/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Pinned_EmptyInputs */



/**
* | output |
* | --- |
* | "Pin voices to use them in the Voices panel." |
*
* @param {Voice_Manager_Pinned_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pinned_empty = /** @type {((inputs?: Voice_Manager_Pinned_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pinned_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épinglez des voix pour les utiliser dans le panneau Voix.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Heften Sie Stimmen an, um sie im Stimmen-Bereich zu verwenden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fissa le voci per usarle nel pannello Voci.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрепите голоса, чтобы использовать их на панели голосов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fija voces para usarlas en el panel de voces.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("固定语音后即可在语音面板中使用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声をピン留めすると、音声パネルで使用できます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज़ों को वॉइस पैनल में उपयोग करने के लिए पिन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Afixe vozes para as utilizar no painel de vozes.")
	return /** @type {LocalizedString} */ ("Pin voices to use them in the Voices panel.")
});